import { render, staticRenderFns } from "./phone-v2.vue?vue&type=template&id=5a3173b8&scoped=true&"
var script = {}
import style0 from "./phone-v2.vue?vue&type=style&index=0&id=5a3173b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3173b8",
  null
  
)

export default component.exports